import React from 'react'
import styled from '@emotion/styled'

type WithChildren<T = {}> = 
T & { 
    children?: React.ReactNode
    onClick?:(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    width?: number
    disabled?: boolean
}

const Content = styled.button`
    margin: 0.5rem;
    padding: 0.5rem;
    border: 0;
    border-radius: 2px 2px 2px 2px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
    outline: none;
    &:hover{
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
        transition: all 0.3s
    }
    &:active{
        background-color: #DBD5E5;
    }
`

export function Button({ children, onClick, width, disabled }: WithChildren){
  return <Content disabled={disabled} onClick={onClick} style={{ width: width, padding: '0.5rem 1rem' }}>
        {children}
    </Content>
}
